export const API_URI = process.env.NODE_ENV === "production" ? "https://bots.termitel.de" : "http://localhost:8123";
export const WIDGET_URI = process.env.NODE_ENV === "production" ? "https://bots.termitel.de/chat" : "http://localhost:7500";
export const GRAPHQL_URI_WS_RS = process.env.NODE_ENV === "production" ? "wss://bots.termitel.de/ws" : "ws://localhost:8123/ws";
